module.exports = __webpack_public_path__ + "static/media/affiliate-tutorial-step-1.139044d9.webp";